import React from 'react';
import { Dropdown, Label, Icon, Message } from 'semantic-ui-react';

/**
 * Book Creator Selection Component
 * Displays dropdown for selecting active Book Creator for testing
 */
const BookCreatorSelector = ({
  bookCreators,
  selectedBookCreator,
  onBookCreatorChange,
  isLoading = false,
  useRealData = false,
  disabled = false
}) => {
  const bookCreatorOptions = Object.entries(bookCreators || {}).map(([id, creator]) => ({
    key: id,
    value: id,
    text: `${creator.name} (${creator.completedProjects || 0} projects)${creator.isRealUser ? ' [Real]' : ' [Mock]'}`,
    icon: 'book'
  }));

  return (
    <div style={{ flex: 1, marginRight: '10px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
        <label style={{ fontWeight: 'bold', marginRight: '10px' }}>
          <Icon name="book" />
          Book Creator
        </label>
        {useRealData && (
          <Label size="mini" color="green">
            <Icon name="database" />
            Real Data
          </Label>
        )}
      </div>

      <Dropdown
        placeholder={isLoading ? "Loading book creators..." : "Select book creator..."}
        fluid
        selection
        loading={isLoading}
        disabled={disabled || isLoading}
        value={selectedBookCreator || ''}
        options={bookCreatorOptions}
        onChange={(e, { value }) => onBookCreatorChange(value)}
        noResultsMessage={
          Object.keys(bookCreators || {}).length === 0
            ? (useRealData ? "No real book creators found." : "No book creators available.")
            : "No matching book creators found"
        }
      />

      {selectedBookCreator && bookCreators[selectedBookCreator] && (
        <div style={{
          marginTop: '8px',
          padding: '8px',
          backgroundColor: bookCreators[selectedBookCreator].isRealUser ? '#e8f5e8' : '#f8f9fa',
          borderRadius: '4px',
          border: bookCreators[selectedBookCreator].isRealUser ? '1px solid #c3e6c3' : '1px solid #dee2e6',
          fontSize: '0.85em'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
            <strong>{bookCreators[selectedBookCreator].name}</strong>
            {bookCreators[selectedBookCreator].isRealUser && (
              <Label size="mini" color="green" style={{ marginLeft: '8px' }}>
                <Icon name="database" />
                Real User
              </Label>
            )}
          </div>
          <div>
            <strong>Projects:</strong> {bookCreators[selectedBookCreator].completedProjects || 0} |
            <strong> Rating:</strong> {bookCreators[selectedBookCreator].rating || 'N/A'} |
            <strong> Status:</strong> {bookCreators[selectedBookCreator].availability || 'N/A'}
          </div>
          {bookCreators[selectedBookCreator].specialties && bookCreators[selectedBookCreator].specialties.length > 0 && (
            <div>
              <strong>Genres:</strong> {bookCreators[selectedBookCreator].specialties.join(', ')}
            </div>
          )}
          {bookCreators[selectedBookCreator].isRealUser && (
            <div>
              <strong>User ID:</strong> {bookCreators[selectedBookCreator].userId} |
              <strong> Profile:</strong> {bookCreators[selectedBookCreator].profileType || 'N/A'}
            </div>
          )}
        </div>
      )}

      {Object.keys(bookCreators || {}).length === 0 && !isLoading && (
        <Message warning size="small" style={{ marginTop: '8px' }}>
          <Message.Header>No Book Creators Available</Message.Header>
          <p>
            {useRealData
              ? "No real book creators could be loaded. Try switching to Mock Data mode."
              : "No mock book creators are available."
            }
          </p>
        </Message>
      )}

      <div style={{ marginTop: '8px', fontSize: '0.8em', color: '#666' }}>
        <Icon name="info circle" />
        {Object.keys(bookCreators || {}).length} book creator{Object.keys(bookCreators || {}).length !== 1 ? 's' : ''} available
      </div>
    </div>
  );
};

export default BookCreatorSelector;
